module.exports = __webpack_public_path__ + "static/media/ui-library.642c163e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/ui-library.png
 ** module id = 665
 ** module chunks = 0
 **/